import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  token: z.string().optional(),
  returnTo: z.string().optional(),
});

export const Route = createFileRoute('/$locale/auth/activate')({
  validateSearch: searchSchema,
});
